(() => {
  const card = document.getElementById('funtek-quote-invite');
  if (!card || window.FuntekQuoteInvite || window.Shopify?.designMode) return;
  const INVITE = 'funtek_quote_invite_until_v1';
  const SUCCESS = 'funtek_rfq_success_until_v1';
  const VISIT = 'funtek_quote_visit_suppressed_v2';
  const DAY = 86400000;
  const memory = {};
  const read = key => { try { return localStorage.getItem(key) ?? memory[key]; } catch { return memory[key]; } };
  const write = (key, value) => { memory[key] = value; try { localStorage.setItem(key, value); } catch {} };
  const visitSuppressed = () => { try { return sessionStorage.getItem(VISIT) === '1' || memory[VISIT]; } catch { return memory[VISIT]; } };
  const suppressVisit = () => { memory[VISIT] = true; try { sessionStorage.setItem(VISIT, '1'); } catch {} };
  const path = location.pathname;
  const reading = /\/blogs\//.test(path) || /guide|calculator|compare|comparison|process|surface-finishes|surface-technology/i.test(path);
  const delay = reading ? 60000 : 40000;
  const drawer = document.querySelector('[id^="funtek-rfq-drawer-"]');
  let elapsed = 0;
  let previous = performance.now();
  let scrolled = false;
  let finished = false;
  let timer;
  const emit = event => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event, page_path:path});
    window.dispatchEvent(new CustomEvent('funtek:rfq-event', {detail:{event}}));
  };
  const hide = () => { card.hidden = true; };
  const stop = () => { finished = true; clearInterval(timer); window.removeEventListener('scroll', onScroll); };
  const suppressed = () => visitSuppressed() || Number(read(INVITE)) > Date.now() || Number(read(SUCCESS)) > Date.now();
  const dismiss = () => { write(INVITE, String(Date.now() + DAY)); hide(); stop(); };
  const isOpen = () => !!drawer?.classList.contains('is-open');
  const opened = () => { suppressVisit(); write(INVITE, String(Date.now() + DAY)); hide(); stop(); };
  const busy = () => isOpen() || [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([aria-hidden="true"]):not([inert])')].some(node => node.checkVisibility({visibilityProperty:true})) || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);
  function onScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY >= Math.min(600, Math.max(120, scrollable * 0.2), scrollable)) scrolled = true;
  }
  function tick() {
    const now = performance.now();
    if (!document.hidden) elapsed += Math.min(now - previous, 2000);
    previous = now;
    if (finished) return;
    if (suppressed()) { hide(); stop(); return; }
    if (document.hidden || elapsed < delay || !scrolled || busy()) return;
    card.hidden = false;
    write(INVITE, String(Date.now() + DAY));
    emit('quote_invite_view');
    stop();
  }
  card.querySelector('.fqi-close').addEventListener('click', () => { dismiss(); emit('quote_invite_dismiss'); });
  card.addEventListener('keydown', event => {
    if (event.key === 'Escape') { dismiss(); drawer?.querySelector('.frq-trigger')?.focus(); }
  });
  card.querySelector('.fqi-quote').addEventListener('click', () => {
    dismiss();
    emit('quote_invite_click');
    if (typeof window.FuntekRfqDrawer?.open === 'function') window.FuntekRfqDrawer.open('quote_invite_card', '');
    else location.href = card.dataset.contactUrl || '/pages/contact';
  });
  card.querySelectorAll('a').forEach(link => link.addEventListener('click', dismiss));
  window.addEventListener('funtek:rfq-event', event => { if (event.detail?.event === 'quote_drawer_open') opened(); });
  window.addEventListener('funtek:inquiry-success', () => { write(SUCCESS, String(Date.now() + 7 * DAY)); opened(); });
  if (drawer) new MutationObserver(() => { if (isOpen()) opened(); }).observe(drawer, {attributes:true,attributeFilter:['class']});
  window.addEventListener('storage', event => { if ((event.key === INVITE || event.key === SUCCESS) && suppressed()) { hide(); stop(); } });
  window.FuntekQuoteInvite = {dismiss};
  if (/\/(cart|checkout|checkouts|account)(\/|$)|thank-you|thank_you|\/pages\/contact(?:\/|$)/.test(path) || suppressed()) { hide(); stop(); return; }
  if (isOpen()) { opened(); return; }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
  document.addEventListener('visibilitychange', () => { previous = performance.now(); if (!document.hidden) tick(); });
  timer = setInterval(tick, 1000);
  window.addEventListener('pagehide', () => clearInterval(timer));
  window.addEventListener('pageshow', event => { if (event.persisted && !finished) { previous = performance.now(); clearInterval(timer); timer = setInterval(tick,1000); } });
})();
